import {
  BrandDetailsFormValues,
  SenderIdConfigurationFormValues,
  TrademarkVerificationFormValues,
} from './types';

export const DefaultBrandDetailsFormValues: BrandDetailsFormValues = {
  companyName: '',
  displayName: '',
  entityType: '',
  vertical: '',
  stockSymbol: '',
  stockExchange: '',
  website: '',
  firstName: '',
  lastName: '',
  phone: '',
  email: '',
  country: '',
  ein: '',
  einIssuingCountry: '',
  street: '',
  city: '',
  state: '',
  postalCode: '',
  businessContactEmail: '',
};

export const DefaultTrademarkVerificationFormValues: TrademarkVerificationFormValues =
  {
    registrationId: '',
    trademarkText: '',
    trademarkOwner: '',
    patentOffice: '',
  };

export const DefaultSenderIdConfigurationFormValues: SenderIdConfigurationFormValues =
  {
    senderIds: [
      {
        senderId: '',
        associatedDcaList: '',
        protectedSenderIdList: '',
      },
    ],
  };
